import { Link } from "react-router-dom";

import { EM_DASH } from "@/lib/utils";

type LinkedNcrRow = {
  id: number;
  repairScrap?: string | null;
  open?: boolean;
  rcaId?: number | null;
};

function statusLabel(ncr: LinkedNcrRow): string {
  if (ncr.open == null) return EM_DASH;
  return ncr.open ? "Open" : "Closed";
}

function dispositionLabel(value: string | null | undefined): string {
  if (value == null || value.trim() === "") return EM_DASH;
  return value;
}

export function QualityLinkedNcrTable({
  ncrs,
  emptyLabel = "No NCRs linked.",
}: {
  ncrs: LinkedNcrRow[];
  emptyLabel?: string;
}): JSX.Element {
  if (ncrs.length === 0) {
    return <p className="text-sm text-slate-600">{emptyLabel}</p>;
  }

  return (
    <div className="overflow-auto">
      <table className="min-w-full text-sm">
        <thead className="sticky top-0 z-10 border-b border-slate-200 bg-slate-50/95 text-left text-xs uppercase tracking-wide text-slate-500">
          <tr>
            <th className="px-2 py-2">Number</th>
            <th className="px-2 py-2">Status</th>
            <th className="px-2 py-2">Disposition</th>
            <th className="px-2 py-2">RCA</th>
          </tr>
        </thead>
        <tbody>
          {ncrs.map((ncr) => (
            <tr key={ncr.id} className="border-b border-slate-100">
              <td className="px-2 py-2 tabular-nums">
                <Link className="text-sky-700 hover:underline" to={`/quality/ncrs/${ncr.id}`}>
                  {ncr.id}
                </Link>
              </td>
              <td className="px-2 py-2">{statusLabel(ncr)}</td>
              <td className="px-2 py-2">{dispositionLabel(ncr.repairScrap)}</td>
              <td className="px-2 py-2 tabular-nums">
                {ncr.rcaId == null ? (
                  EM_DASH
                ) : (
                  <Link className="text-sky-700 hover:underline" to={`/quality/rcas/${ncr.rcaId}`}>
                    {ncr.rcaId}
                  </Link>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
